import { render, staticRenderFns } from "./collection-add-list.vue?vue&type=template&id=24e4d6e5&scoped=true"
import script from "./collection-add-list.vue?vue&type=script&lang=ts"
export * from "./collection-add-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e4d6e5",
  null
  
)

export default component.exports